import React, { useEffect } from 'react';

// Import images from assets
import icon1 from '../../assets/icons/11.png';
import icon6 from '../../assets/icons/12.png';
import icon2 from '../../assets/icons/14.png';
import icon4 from '../../assets/icons/13.png';
import icon5 from '../../assets/icons/16.png';
import icon3 from '../../assets/icons/15.png';

const TopFeatures = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const features = [
    { img: icon1, title: "Schedule Visit" },
    { img: icon6, title: "Wellness Plans" },
    { img: icon4, title: "Virtual Care" },
    { img: icon2, title: "Global Patients" },
    { img: icon5, title: "Meet Specialist" },
    { img: icon2, title: "Corporate Support" },
    { img: icon3, title: "Kidney Health Education" },
  ];

  return (
    <div style={{ padding: "20px", backgroundColor: '#f1f1f1' }}>
      <div className="features-container">
        {features.map((feature, index) => (
          <div className="feature-card" key={index}>
            <img
              src={feature.img}
              alt={feature.title}
              className="feature-icon"
            />
            <span className="feature-title">{feature.title}</span>
          </div>
        ))}
      </div>

      <style>{`
  .features-container {
    display: flex;
    justify-content: center;
    gap: 14px;
    flex-wrap: wrap;
  }

  .feature-card {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 15px 20px;
    border: 1px solid #ddd;
    border-radius: 20px;
    background: #fff;
    box-shadow: 0 2px 8px rgba(0,0,0,0.1);
    width: 160px;
    text-align: center;
    flex: 0 0 auto;
  }

  .feature-icon {
    width: 60px;
    height: 60px;
    object-fit: contain;
    margin-bottom: 10px;
  }

  .feature-title {
    font-size: 14px;
    font-weight: 500;
  }

  /* Mobile only: horizontal scroll */
  @media (max-width: 768px) {
    .features-container {
      flex-wrap: nowrap;
      overflow-x: auto;
      justify-content: flex-start;
      padding-bottom: 10px;
      scrollbar-width: none; /* Firefox */
    }
    .features-container::-webkit-scrollbar {
      display: none; /* Chrome/Safari/Edge */
    }
    .feature-card {
      min-width: 140px; /* ensures proper horizontal scrolling */
    }
  }
`}</style>

    </div>
  );
};

export default TopFeatures;
